import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromNotifications from '@main-application/notifications/reducers/notifications.reducer';

export const selectNotificationsState = createFeatureSelector<fromNotifications.State>(
  fromNotifications.notificationsFeatureKey
);

/**
 * get last notification list
 */
export const selectLastNotificationList = createSelector(
  selectNotificationsState,
  notificationsState => notificationsState.lastNotificationList
);
export const selectLastNotificationListLoading = createSelector(
  selectNotificationsState,
  notificationsState => notificationsState.lastNotificationListLoading
);

/**
 * get last any notification
 */
export const selectLastAnyNotificationList = createSelector(
  selectNotificationsState,
  notificationsState => notificationsState.lastAnyNotificationList
);

/**
 * mark selected as read
 */
export const selectMarkAsReadInProgress = createSelector(
  selectNotificationsState,
  notificationsState => notificationsState.markAsReadInProgress
);
export const selectMarkAsReadStatus = createSelector(
  selectNotificationsState,
  notificationsState => notificationsState.markAsReadStatus
);
export const selectMarkAsReadId = createSelector(
  selectNotificationsState,
  notificationsState => notificationsState.markAsReadId
);

/**
 * delete notification
 */
export const selectDeleteNotificationInProgress = createSelector(
  selectNotificationsState,
  notificationsState => notificationsState.deleteNotificationInProgress
);
